<template>
  <layout>
    <div v-if="!maxSmall">
      <actions :can-create-location="props.canCreateLocation" />
      <div class="dynamic-height overflow-scroll">
        <div role="list" class="flex flex-wrap gap-2 p-6">
          <location-card
            class="cursor-pointer"
            v-for="tenant in tenants"
            :key="tenant.id"
            :tenant="tenant"
            @click="handleLocationClicked(tenant.id)"
          />
        </div>
      </div>
    </div>
    <div v-else class="h-full bg-gray-50 pb-4">
      <div
        class="sticky top-0 space-y-1 pb-4 pt-6 px-4 sm:p-6 bg-white flex-col space-y-2 items-center justify-between border-b border-b-gray-200 z-30"
      >
        <ArrowNarrowLeft
          class="w-6 md:w-0 md:hidden -ml-0.5 text-gray-900"
          @click="handleBack"
        />
        <div class="flex items-center justify-between">
          <h1 class="text-gray-900 text-xl font-medium">
            {{ t("admin.settings.organisation.buildings") }}
          </h1>
          <PlusIcon
            v-if="props.canCreateLocation"
            class="w-10 text-gray-900 sm:hidden -mr-1"
            @click="isAddingBuilding = true"
          />
        </div>
      </div>

      <div class="flex flex-col space-y-4 px-4 mt-4">
        <location-card
          class="cursor-pointer"
          v-for="tenant in tenants"
          :key="tenant.id"
          :tenant="tenant"
          @click="handleLocationClicked(tenant.id)"
        />
      </div>
    </div>
    <add-building :open="isAddingBuilding" @close="isAddingBuilding = false" />
  </layout>
</template>

<script setup>
import PersistentLayout from "@/Layouts/PersistentLayout.vue";
import Layout from "@/Tailwind/Pages/Settings";
import { computed, defineProps, ref } from "vue";
import { usePage } from "@inertiajs/vue3";
import LocationCard from "@/Tailwind/Components/Settings/LocationCard";
import Actions from "@/Tailwind/Components/Settings/Actions";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import ArrowNarrowLeft from "@/Tailwind/Icon/ArrowNarrowLeft.vue";
import PlusIcon from "@/Tailwind/Icon/PlusIcon.vue";
import AddBuilding from "@/Tailwind/Components/AddBuilding.vue";

import { useI18n } from "vue-i18n";
const { t } = useI18n();

let isAddingBuilding = ref(false);
const { maxSmall } = useBreakpoints();

defineOptions({ layout: PersistentLayout });

const props = defineProps({
  canCreateLocation: {
    type: Boolean,
  },
});

const handleLocationClicked = (locationId) => {
  if (!maxSmall.value) {
    // Always show the notifications page first
    // This page the user will always have access to
    router.visit(route("settings.location.index", [locationId]));
    return;
  }

  router.visit(route("settings.tenant", locationId));
};

function handleBack() {
  router.visit(route("settings.organisation.index"));
}

const tenants = computed(() => usePage().props.tenants);
</script>

<style lang="scss" scoped>
.dynamic-height {
  height: calc(100vh - 64px - 102px);
}
</style>
